<template>
  <b-modal hide-footer centered v-model="showModal">
    <template #modal-title> Change Status </template>

    <b-form-group
      label-for="status"
      class="w-100 pt-1"
      label="Change the current status"
    >
      <b-button-group class="mt-1">
        <button
          class="btn text-white mx-25  hover-warning"
          :class="status == 'PENDING' ? ' bg-warning' : ' '"
          @click="status = 'PENDING'"
          style="border-top-left-radius: 20px; border-bottom-left-radius: 20px"
        >
          Pending
        </button>
        <!-- <button
          class="btn text-white mx-25 hover-primary"
          :class="status == 'READY_TO_BUY' ? ' bg-info' : '  '"
          @click="status = 'READY_TO_BUY'"
        >
          Ready to pay
        </button> -->
        <button
          class="btn text-white mx-25 hover-success"
          :class="status == 'ACCEPTED' ? ' bg-success' : '  '"
          @click="status = 'ACCEPTED'"
        >
          Accepted
        </button>
        <button
          class="btn text-white mx-25 hover-danger"
          :class="status == 'REJECTED' ? 'bg-danger' : '    '"
          @click="status = 'REJECTED'"
          style="
            border-top-right-radius: 20px;
            border-bottom-right-radius: 20px;
          "
        >
          Rejected
        </button>
      </b-button-group>
    </b-form-group>
    <div class="w-100 d-flex align-items-center justify-content-end">
      <b-button
        @click="changeStatus"
        class="gradient-btn mb-1"
        :disabled="status == item.verify_status"
      >
        {{ status == item.verify_status ? "Current status" : "Change status" }}
      </b-button>
    </div>
    <loader :loading="loading" />
  </b-modal>
</template>

<script>
import { BModal, BFormGroup, BButton, BButtonGroup } from "bootstrap-vue";
import Loader from "@core/components/loader/Loader.vue";

export default {
  components: {
    BModal,
    BFormGroup,
    BButton,
    BButtonGroup,
    Loader,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    showModal: {
      set(newVal) {
        this.$emit("input", newVal);
      },
      get() {
        return this.visible;
      },
    },
  },
  watch: {
    item(val) {
      this.status = val.verify_status;
    },
  },

  data() {
    return {
      loading: false,
      status: "",
    };
  },

  methods: {
    async changeStatus() {
      this.loading = true;
      try {
        const { data } = await this.$http.post(
          "/panel/competitions/" + this.item.id + "/toggle?_method=patch",
          {
            verify_status: this.status,
          }
        );
        this.showModal = false;
        this.$emit("updateCompetitions");
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>

<style   scoped>
.btn{
 background-color: #252531 ;
    border: 1px solid #ffffff0d  ;
}

 
</style>> 
